var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.authPages)?_c('div',{attrs:{"id":"layout-wrapper"}},[_c('Header'),_c('Sidebar'),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1):_c('div',{staticClass:"account-pages my-5 pt-sm-5"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }